/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { withTheme } from 'emotion-theming';
import BonusIcon from 'app/components/icons/BonusIcon';
import LabelsList from 'app/components/static/LabelsList';
import Label from 'app/components/commons/Label';
import LabelledIcon from 'app/components/commons/LabelledIcon';
import Loader from 'app/components/commons/Loader';
import t from 'app/utils/translate';
import { LIVE, PENDING, SCHEDULED, TICK } from 'app/constants/iconTypes';
import FunkyIcon from 'app/components/commons/FunkyIcon';

type Props = {
  bonuses: Array<Object>,
  isLoading?: boolean,
  labels: Array<Object>,
  placeholder?: string
};

const defaultProps = {
  isLoading: false,
  placeholder: undefined
};

const Divider = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis5,
  height: 1,
  width: '90%',
  margin: 'auto',
  marginTop: theme.spacing.small,
  marginBottom: theme.spacing.small
}));

const NoData = styled.div({
  textAlign: 'center'
});

const StyledLabel = ({ item = {} }: any) => (
  <Label bgColor={item.bgColor} textColor={item.textColor}>
    {item.name}
  </Label>
);

function LabelsContent({ bonuses, labels, isLoading, placeholder }: Props) {
  if (isLoading) {
    return <Loader kind="dark" />;
  }

  if (labels.length === 0) {
    return <NoData>{t(placeholder || 'Labels not found')}</NoData>;
  }

  return (
    <div>
      <LabelsList
        items={labels}
        render={item => (
          <LabelledIcon icon={<StyledLabel item={item} />}>{item.description}</LabelledIcon>
        )}
      />
      <Divider />
      {bonuses.length > 0 && (
        <LabelsList
          items={bonuses}
          render={item => (
            <LabelledIcon icon={<BonusIcon id={item.id} name={item.name} />}>
              {item.description}
            </LabelledIcon>
          )}
        />
      )}
      {bonuses.length > 0 && <Divider />}
      <LabelsList
        items={[
          { label: t('Scheduled'), id: SCHEDULED },
          { label: t('In progress'), id: LIVE },
          { label: t('In review'), id: PENDING },
          { label: t('Completed'), id: TICK }
        ]}
        render={item => (
          <LabelledIcon icon={<FunkyIcon type={item.id} />}>{item.label}</LabelledIcon>
        )}
      />
    </div>
  );
}

LabelsContent.defaultProps = defaultProps;

export default withTheme(LabelsContent);
